export default "__VITE_ASSET__D11CTaVj__"